export interface CheckOfficialAcceptCollectionRequest {
  id: number
  collectionType: string
  handlingType: string
  appendixCode: string
  traderCode: string
  acceptDate: string
  acceptPrice: number | string
  shelfType: string
  mark: string
  ndc: string
  book: string
  sub: string
  publishDate: string
}

export function CheckOfficialAcceptCollectionRequestToJSON(
  value: CheckOfficialAcceptCollectionRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    appendix_code: value.appendixCode !== '' ? value.appendixCode : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    accept_date: value.acceptDate !== '' ? value.acceptDate : undefined,
    accept_price: value.acceptPrice !== 0 ? value.acceptPrice : undefined,
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    mark: value.mark !== '' ? value.mark : undefined,
    ndc: value.ndc !== '' ? value.ndc : undefined,
    book: value.book !== '' ? value.book : undefined,
    sub: value.sub !== '' ? value.sub : undefined,
    publish_date: value.publishDate !== '' ? value.publishDate : undefined
  }
}
